import React, { useEffect, useState } from 'react';
import { Box, Fade, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { toast } from 'material-react-toastify';
import { useNavigate } from 'react-router-dom';
import { sharedColors } from '../../utils/Style';
import { SliderSlide } from '../../interfaces/Slider/SliderSlide';
import { getSliderSlides } from '../../api/Slider';

export function SliderCarousel() {
  const navigate = useNavigate();

  const [hovering, setHovering] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [slideIn, setSlideIn] = useState(true);
  const [slides, setSlides] = useState<SliderSlide[]>([]);

  useEffect(() => {
    getSliderSlides()
      .then((s) => setSlides(s))
      .catch((err) => toast.error(err.message));
  }, []);

  const handleNext = () => {
    if (!slides.length) return;

    setSlideIn(false);
    setTimeout(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
      setSlideIn(true);
    }, 300);
  };

  const handlePrev = () => {
    setSlideIn(false);
    setTimeout(() => {
      setActiveIndex((prev) => (prev - 1 + slides.length) % slides.length);
      setSlideIn(true);
    }, 300);
  };

  useEffect(() => {
    const t = setTimeout(handleNext, 5000);

    return () => clearTimeout(t);
  }, [activeIndex, slides]);

  return slides.length ? (
    <Box
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      sx={{
        width: '100%',
        position: 'relative',
      }}
    >
      <Fade in={slideIn} timeout={300}>
        <Box
          key={slides[activeIndex].id}
          component='img'
          src={slides[activeIndex].path}
          onClick={
            slides[activeIndex].url
              ? () => navigate(slides[activeIndex].url!)
              : undefined
          }
          sx={{
            width: '100%',
            height: 'auto',
            display: 'block',
            cursor: slides[activeIndex].url ? 'pointer' : undefined,
          }}
        />
      </Fade>

      <Box
        onClick={handlePrev}
        sx={{
          position: 'absolute',
          top: '50%',
          left: 0,
          transform: 'translateY(-50%)',
          zIndex: 2,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: sharedColors.gray7,
          opacity: hovering && slides.length > 1 ? 0.8 : 0,
          cursor: 'pointer',
        }}
      >
        <IconButton sx={{ color: sharedColors.white }}>
          <ChevronLeftIcon />
        </IconButton>
      </Box>

      <Box
        onClick={handleNext}
        sx={{
          position: 'absolute',
          top: '50%',
          right: 0,
          transform: 'translateY(-50%)',
          zIndex: 2,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: sharedColors.gray7,
          opacity: hovering && slides.length > 1 ? 0.8 : 0,
          cursor: 'pointer',
        }}
      >
        <IconButton sx={{ color: sharedColors.white }}>
          <ChevronRightIcon />
        </IconButton>
      </Box>
    </Box>
  ) : (
    <></>
  );
}
